<div class="innerpage-fullwithbanner" *ngIf="!callFromComponent">
  <h2 class="bighead" *ngIf="interest==false">My Profile</h2>
  <h2 class="bighead" *ngIf="interest==true">Acquisition Criteria</h2>
  <ul class="bread-crumbs">
    <li *ngIf="this.authService.Principal() || this.authService.Seller() || this.authService.Principal1031()">
      <a (click)="onHomeBreadCrumbClick();">
        Home
        <span>|</span>
      </a>
    </li>
    <li *ngIf="!this.authService.Principal() && !this.authService.Seller() && !this.authService.Principal1031()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
    <li *ngIf="CurrentPage!=null&&CurrentPage!=''&&CurrentPage=='PrincipalDashboard'"><a (click)="onPrincipalDashboardClick();">My Portal<span>|</span></a></li>
    <li *ngIf="interest==false">My Profile</li>
    <li *ngIf="interest==true">Acquisition Criteria</li>
  </ul>
</div>
<div class="section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="border-div margin-bottom-0" style="margin-bottom:10px !important;">
      <div class="tabstyle2 offerdetailstab-padding pos-relative" *ngIf="userDetailsOutput.UserRoleId !== 7">
        <ul class="switchingproperty margin-bottom-15 offerlistingtab">
          <li [class.active]="activeTab === tab.PersonalInformation">
            <a (click)="onTabClick(tab.PersonalInformation)">
              Profile
            </a>
          </li>
          <li [class.active]="activeTab === tab.InterestCriteria" *ngIf="(userDetailsOutput.UserRole == authService.getUserRoleDescription(this.authService.UserRole.Principal))||(userDetailsOutput.UserRole == authService.getUserRoleDescription(this.authService.UserRole.Principal1031))">
            <a (click)="onTabClick(tab.InterestCriteria)">
              Acquisition Criteria
            </a>
          </li>
          <li [class.active]="activeTab === tab.Notifications" *ngIf="authService.Broker()">
            <a (click)="onTabClick(tab.Notifications)">
              Notifications
            </a>
          </li>
        </ul>
      </div>
      <div [hidden]="activeTab !== tab.PersonalInformation">

        <div class="floatinghead floatinghead-xs clearfix">
          <h2 class="mainhead" style="margin-bottom:30px !important"><span class="text">Profile</span></h2>
          <button class="right-btn btn  btn-circle btn-green adduserbtn" *ngIf="!callFromComponent&&this.userDetailsOutput.Id>0" (click)="editUser();" href="#" placement="top" tooltip="Edit Profile" ng-reflect-tooltip="Edit" ng-reflect-placement="top"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></button>
        </div>
        <div class="leftsideprofile">
          <div class="profilepic">
            <img src="{{userDetailsOutput.ProfilePicPath}}">
          </div>
        </div>
        <div class="rightsideprofile margin-bottom-20">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">First name</label>
                <h6 class="displayvalue">{{userDetailsOutput.FirstName}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Last Name</label>
                <h6 class="displayvalue">{{userDetailsOutput.LastName}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Email</label>
                <h6 class="displayvalue truncate-email">{{userDetailsOutput.Email}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Phone</label>
                <h6 class="displayvalue">{{userDetailsOutput.Phoneno | phone}}</h6>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Address Line 1</label>
                <h6 class="displayvalue">{{userDetailsOutput.Address1!=null && userDetailsOutput.Address1!="" ?userDetailsOutput.Address1:"-"}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Address Line 2</label>
                <h6 class="displayvalue">{{userDetailsOutput.Address2!=null && userDetailsOutput.Address2!="" ?userDetailsOutput.Address2:"-"}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">State</label>
                <h6 class="displayvalue">{{userDetailsOutput.State!=null && userDetailsOutput.State!=""?userDetailsOutput.State:"-"}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">City</label>
                <h6 class="displayvalue">{{userDetailsOutput.CityName!="" && userDetailsOutput.CityName!=null?userDetailsOutput.CityName:"-"}}</h6>
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">ZIP</label>
                <h6 class="displayvalue">{{userDetailsOutput.Zip!="" && userDetailsOutput.Zip!=null?userDetailsOutput.Zip:"-"}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Role</label>
                <h6 class="displayvalue">{{userDetailsOutput.UserRole}}</h6>
              </div>
            </div>
            <!--<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                    <label class="form-label">Location</label>
                    <h6 class="displayvalue"><span class="tags">IL</span><span class="tags">Texas</span><span class="tags">Florida</span></h6>
                </div>
            </div>-->
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">User Status</label>
                <h6 class="displayvalue" [ngClass]="_validationService.applyClass(userDetailsOutput.UserStatus)">{{userDetailsOutput.UserStatus}}</h6>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Company Name</label>
                <h6 class="displayvalue">{{userDetailsOutput.CompanyName?userDetailsOutput.CompanyName:'-'}}</h6>
              </div>
            </div>
            <div class="col-lg-6 col-md-3 col-sm-6 col-xs-12">
              <div class="form-group" *ngIf="userDetailsOutput.UserRoleId === 3 ||
                   userDetailsOutput.UserRoleId === 1
">
                <label class="form-label">LinkedIn</label>
                <h6 class="displayvalue">{{userDetailsOutput.UserLinkedInProfile?userDetailsOutput.UserLinkedInProfile:'-'}}</h6>
              </div>
            </div>
            <!--<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                    <label class="form-label">ZIP</label>
                    <h6 class="displayvalue">61257</h6>
                </div>
            </div>-->
          </div>
        </div>
        <div *ngIf="IsSeller" [hidden]="true">
          <div class="floatinghead clearfix">
            <h2 class="mainhead "><span class="text">Tickers</span></h2>
          </div>
          <div class="table-responsive">
            <table class="table basictable">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Symbol</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of tickers;let i = index">
                  <td>
                    <p>{{item.Name}}</p>
                  </td>
                  <td>
                    <p>{{item.Symbol}}</p>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="tickers?.length == 0 ">
                  <td colspan="2" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Tickers Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <div class="clearfix"></div>
        <div *ngIf="ShowbrokerRegionalLicenses && userDetailsOutput.UserRoleId != 9">
          <div class="floatinghead clearfix">
            <h2 class="mainhead" style="margin-bottom:30px !important;"><span class="text">Broker Regional Licenses Details</span></h2>
          </div>
          <div class="table-responsive">
            <table class="table basictable">
              <thead>
                <tr>
                  <th>#</th>
                  <th>State</th>
                  <th>License No.</th>
                  <th>Expiration Date</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let field of brokerRegionalLicenses;let i = index">
                  <td><p>{{i+1}}</p></td>
                  <td>
                    <p>{{field.StateName}}</p>
                  </td>
                  <td>
                    <p>{{field.BrokerLicense}}</p>
                  </td>
                  <td>
                    <p>{{field.ExpiryDate_Date| date:'MM/dd/yyyy' }}</p>
                  </td>
                  <td>
                    <i *ngIf="field.IsDefault == true" class="icon-tick icon" aria-hidden="true"></i>
                    <!--<p>{{field.IsDefault == true ? 'Default' : '' }}</p>-->
                  </td>
                </tr>



              </tbody>

              <tfoot>
                <tr *ngIf="brokerRegionalLicenses?.length == 0">
                  <td colspan="9" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="margin-top-30" *ngIf="userDetailsOutput.UserRoleId === 9">
          <div class="floatinghead floatinghead-xs clearfix">
            <h2 class="mainhead "><span class="text">Brokerages</span></h2>
          </div>


          <div class="table-responsive">
            <table class="table basictable">
              <thead>
                <tr>

                  <th>Brokerage Name</th>
                  <th>Brokerage URL</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let field of result;let i = index">
                  <td>
                    <p>{{field.BrokerageName}}</p>
                  </td>
                  <td>
                    <p><a href="{{_validationService.formatURL(field.WebsiteURL)}}" target="_blank">{{field.WebsiteURL}}</a></p>
                  </td>

                </tr>

              </tbody>
              <tfoot>
                <tr *ngIf="result?.length == 0 ">
                  <td colspan="9" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div *ngIf="showPropertyAssociated">

          <div class="floatinghead clearfix">
            <h2 class="mainhead"><span class="text">Properties Associated</span></h2>
            <!--<button class="right-btn btn  btn-circle btn-green adduserbtn" href="#" ng-reflect-placement="top" ng-reflect-tooltip="Assign Property" placement="top" tooltip="Assign Property"><i aria-hidden="true" class="icofont icofont-plus icon"></i></button>-->
          </div>
          <h3 class="bluelabel">Sale</h3>
          <!--<h3 class="bluelabel">Sale | <span>1031</span></h3>-->
          <div class="table-responsive">
            <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
              <thead>
                <tr>
                  <th>Tenant</th>
                  <th>Broker</th>
                  <th>Property Status</th>
                  <th>Asking Price</th>
                  <th>Credit Rating</th>
                  <th>Cap Rate</th>
                  <th>Remaining Term</th>
                  <th>Lease Structure</th>
                  <th>Area</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let property of propertiesAssociated">
                  <td>
                    <p><a href="#" routerLink="/viewproperty/{{property.Guid}}">{{property.PropertyName}}</a></p>

                  </td>
                  <td>
                    <p>{{property.BrokerName}}</p>
                  </td>
                  <td>
                    <p [ngClass]="{'redtextlabel':property.PropertyStatus === 'Closed','greentextlabel':property.PropertyStatus === 'Available','orangetextlabel':property.PropertyStatus === 'Under Contract','Off-Market':property.PropertyStatus === 'Off-Market'}">{{property.PropertyStatus }}</p>
                  </td>
                  <td>
                    <p>{{property.Price | currency}}</p>
                  </td>
                  <td>
                    <p>{{property.CreditRating}}</p>
                  </td>
                  <td>
                    <p>{{property.CapRate == null ? '' : property.CapRate +'%' }}</p>
                  </td>
                  <td>
                    <p>{{property.RemainingTerm == null ? '' : property.RemainingTerm + 'Months'}}</p>
                  </td>
                  <td>
                    <p>{{property.LeaseStructure}}</p>
                  </td>
                  <td>
                    <p>{{property.BuildingSize == null ? '' : (property.BuildingSize | number) + 'SQFT' }}</p>
                  </td>

                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="propertiesAssociated?.length == 0 ">
                  <td colspan="9" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

        </div>

      </div>
      <div class="clearfix" *ngIf="interest&&currentuserid!=0">
        <div class="col-md-12">
          <!--<app-audit-trail [propertyView]="true" [User]="User" [exchangeId]="exchangeId" [isExchangeAudit]="false" [exchangeOwner]="exchangeOwner"></app-audit-trail>-->

          <app-add-interest-criteria [IsInitialLoad]="1" [UserId]="currentuserid"></app-add-interest-criteria>
        </div>
      </div>
      <div class="clearfix" *ngIf="activeTab === tab.Notifications&&authService.Broker()">
        <div class="col-md-12">
          <app-users-notifications></app-users-notifications>
        </div>
      </div>
    </div>
    <div class="container container-lg margin-bottom-40" *ngIf="isFromExchange1031 &&interest==false ">
      <div class="row">
        <accordion class="accordion-wrapper">
          <accordion-group heading="{{userDetailsOutput.FirstName}} 's Activity Log" [isOpen]="true">
            <div class="col-md-12">
              <app-audit-trail [propertyView]="true" [User]="User" [exchangeId]="exchangeId" [isExchangeAudit]="false" [exchangeOwner]="exchangeOwner"></app-audit-trail>
            </div>
          </accordion-group>
          <accordion-group heading="Exchange Activity Log" (isOpenChange)="openExchangeLog($event)">
            <div class="col-md-12">
              <app-audit-trail [propertyView]="true" [User]="User" [exchangeId]="exchangeId" [isExchangeAudit]="true" [exchangeOwner]="exchangeOwner"></app-audit-trail>
            </div>
          </accordion-group>
        </accordion>
      </div>
    </div>
  </div>
</div>
<button id="openModalButton" [hidden]="true" (click)="openLoginModal(loginpopup,'commonmodal')"></button>
<ng-template #loginpopup>
  <app-login-form [modalRef]="modalRef"></app-login-form>
</ng-template>

